import React from "react";
import "./ThreeDotsLoader.css";

export default function ThreeDotsLoader({}) {
  return (
    <div className="three-dots-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
